export const QA_NAME_FORM_NOTIFICATION = 'formInlineNotificationItem'
